module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fb-Ga-Hc-Ia.92188836.png";